export const REDUX_NAMESPACE = 'app/uploads/';
export const REDUXACTIONS_STRUCTURE = {
  uploadRequest: ['filename', 'file'],
  uploadSuccess: ['oldFileName', 'newFileName'],
  uploadFailure: ['error'],
  convertRequest: ['filename', 'file'],
  convertSuccess: ['oldFileName', 'newFileName'],
  convertFailure: ['error'],
};
